import React from 'react'
import Navbar from './Navbar'

function Contact() {

    return (
      <Navbar />
    )
  }

export default Contact